import Immutable from 'app/utils/immutable/Immutable';
import { LOAD_AVATAR_STARTED, LOAD_AVATAR } from 'store/actions/entities/relatedEntitiesActions';

const reducer = (state = Immutable({}), action) => {
    const { type, meta, payload, error } = action;
    switch (type) {
        case LOAD_AVATAR_STARTED:
            return Immutable({
                ...state,
                [meta.uri]: { isLoading: true },
            });

        case LOAD_AVATAR:
            if (error) {
                return Immutable({
                    ...state,
                    [meta.uri]: { isLoading: false },
                });
            }
            return Immutable({
                ...state,
                [meta.uri]: { isLoading: false, loadedAt: Date.now(), ...payload[0] },
            });

        default:
            return state;
    }
};

export default reducer;
